import { CHART_COLORS } from './chartColors';

export const FONT_FAMILY = "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";

export const DATA_LABEL_STYLE = {
  fontSize: '10px',
  fontWeight: '700',
  color: CHART_COLORS.textPrimary,
  textOutline: `2px ${CHART_COLORS.borderStrong}`,
  fontFamily: FONT_FAMILY,
};
